import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';
import { BlockPlainTextAdapterExtension } from '@blocksuite/affine-shared/adapters';

import { createEmbedBlockPlainTextAdapterMatcher } from '../../common/adapters/plain-text.js';

export const embedVideoBlockPlainTextAdapterMatcher =
  createEmbedBlockPlainTextAdapterMatcher(EmbedVideoBlockSchema.model.flavour);

export const EmbedVideoBlockPlainTextAdapterExtension =
  BlockPlainTextAdapterExtension(embedVideoBlockPlainTextAdapterMatcher);
